import React from 'react';

function Dashboard({ totalReviewsCount, totalProductsCount, totalVendorsCount, topPerformingImages, API_BASE_URL }) {
    return (
        <div>
            <h1 className="text-3xl font-bold text-center mb-8 text-gray-800">Dashboard Overview</h1>

            {/* KPIs Section */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
                <div className="bg-blue-500 text-white p-6 rounded-lg shadow-md text-center">
                    <p className="text-5xl font-extrabold">{totalReviewsCount}</p>
                    <p className="text-xl mt-2">Total Reviews</p>
                </div>
                <div className="bg-green-500 text-white p-6 rounded-lg shadow-md text-center">
                    <p className="text-5xl font-extrabold">{totalProductsCount}</p>
                    <p className="text-xl mt-2">Total Products</p>
                </div>
                <div className="bg-purple-500 text-white p-6 rounded-lg shadow-md text-center">
                    <p className="text-5xl font-extrabold">{totalVendorsCount}</p>
                    <p className="text-xl mt-2">Total Vendors</p>
                </div>
            </div>

            {/* Top Performing Images Section */}
            <div className="mb-8 p-6 border rounded-lg bg-gray-50 shadow-sm">
                <h2 className="text-2xl font-semibold mb-6 text-gray-800">Top Performing Images (Rating &ge; 4)</h2>
                {topPerformingImages.length === 0 ? (
                    <p className="text-gray-600 text-center">No images with average rating 4 or higher found yet.</p>
                ) : (
                    <div className="overflow-x-auto">
                        <table className="min-w-full divide-y divide-gray-200">
                            <thead className="bg-gray-100">
                                <tr>
                                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                        Image Preview
                                    </th>
                                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                        Vendor
                                    </th>
                                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                        Rating (1-5)
                                    </th>
                                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                        Image Name
                                    </th>
                                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                        Total Reviews
                                    </th>
                                </tr>
                            </thead>
                            <tbody className="bg-white divide-y divide-gray-200">
                                {topPerformingImages.map((image) => (
                                    <tr key={image.unique_image_id}>
                                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                            {image.imageUrl && (
                                                <img src={image.imageUrl} alt={image.filename} className="h-16 w-16 object-cover rounded-md" />
                                            )}
                                        </td>
                                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{image.vendor_name || 'N/A'}</td>
                                        <td className="px-6 py-4 whitespace-nowrap text-sm font-bold text-blue-700">
                                            {image.averageScore}
                                        </td>
                                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{image.filename}</td>
                                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                            {image.totalReviews}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>
        </div>
    );
}

export default Dashboard;
